import { render, staticRenderFns } from "./PageCommunityRules.vue?vue&type=template&id=23910929&scoped=true&"
import script from "./PageCommunityRules.vue?vue&type=script&lang=js&"
export * from "./PageCommunityRules.vue?vue&type=script&lang=js&"
import style0 from "./PageCommunityRules.vue?vue&type=style&index=0&id=23910929&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23910929",
  null
  
)

export default component.exports